import React from 'react';
import { DynamicContentSection } from './DynamicContentSection';

export const IndustryExperienceSection: React.FC = () => {
  return (
    <DynamicContentSection 
      contentKey="IndustryExperience"
      layout="image-right"
      showCta={false} // Hidden until destination page is created
      showSingleImage={true}
      image1Src="/images/project_domains.png"
      image1Alt="CISCODE industry experience across multiple sectors"
    />
  );
};